import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { ExternalBetslipActions } from 'packages/sports/common/betslip/core/external-betslip-actions';

import { getBetslipGroupInformation } from '../../../betbuilder/utils';
import { getPickIds } from '../../../option-group/precreated-group-option-utils';
import {
    AddToBetslipPayload,
    BetBuilderPickIdType,
    CreatePickPayload,
    IBetBuilderBetSlipService,
    RemoveFromBetslipPayload,
} from './bet-builder-betslip-service.model';

@Injectable({ providedIn: 'root' })
export class BetBuilderGroupBetslipService implements IBetBuilderBetSlipService {
    constructor(private store: Store) {}

    addToBetslip({ event, betBuilderPickIds, tracking }: AddToBetslipPayload): void {
        if (!betBuilderPickIds) {
            return;
        }

        const picks = betBuilderPickIds.map((id) => {
            return {
                pickId: id,
                tracking: tracking,
                groupInfo: getBetslipGroupInformation(event),
                isBetBuilder: true,
            };
        });

        this.store.dispatch(ExternalBetslipActions.addGroupPick({ picks }));
    }

    removeFromBetslip({ pickIds }: RemoveFromBetslipPayload): void {
        this.store.dispatch(ExternalBetslipActions.removePicksFromGroup({ pickIds }));
    }

    createPicks({ precreatedGroup, eventOptionGroups }: CreatePickPayload): BetBuilderPickIdType[] {
        if (!precreatedGroup || !eventOptionGroups) {
            return [];
        }

        return getPickIds(precreatedGroup, eventOptionGroups);
    }
}
